export const GET_FUNCTIONS_START = 'GET_FUNCTIONS_START';
export const GET_FUNCTIONS_SUCCESS = 'GET_FUNCTIONS_SUCCESS';
export const GET_FUNCTIONS_FAIL = 'GET_FUNCTIONS_FAIL';

export const GET_FUNCTION_STATISTICS_START = 'GET_FUNCTION_STATISTICS_START';
export const GET_FUNCTION_STATISTICS_SUCCESS = 'GET_FUNCTION_STATISTICS_SUCCESS';
export const GET_FUNCTION_STATISTICS_FAIL = 'GET_FUNCTION_STATISTICS_FAIL';
